<template>
  <el-dialog :close-on-click-modal="false" class="tx-c" :visible="visible" append-to-body title="支付界面" @close="cancel" width="50rem" top="10vh">
    <el-main style="padding: 0 10px; height: 31rem">
      <el-row>
        <el-col>需要支付的金额:{{infoDetail.amount}}</el-col>
        <el-col>{{state}}</el-col>
      </el-row>
      <el-row style="margin-top: 20px;">
          <el-button size="large" @click.native="$emit('update:visible', false)" class="w100">关闭</el-button>
          <el-button :loading="meta.loading" class="w100" @click="submit" type="primary" style="margin-left: 1rem" size="large">支付成功</el-button>
         
      </el-row>
      
    </el-main>
  </el-dialog>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";

export default {
  components: {
    
  },
  props: {
    infoDetail:Object,
    visible: Boolean
  },
  data() {
    return {
      state:'等待支付',
      meta:{
        loading:false,
      }
    };
  },
  computed: {
    ...mapGetters(["dict", , "Enum", "dictEnum","user", "permission"])
  },
  filters:{
   
  },
  watch:{
  },
  mounted() {
   
  },
  methods: {
    
    
    submit(type){
      
      this.meta.loading = true
      // if(this.title == '交预交金'){
        let params = this.infoDetail

        api.addDeposit(params).then((res)=>{
          console.log('返回数据：',res)
          this.$emit("close");
          if(params.checked){
            return this.addCounts(res.id)
          }
          this.meta.loading = false;
          this.$message.success("交费成功")
          this.$emit('closePay')
          this.cancel()
        }).catch((err)=>{
          this.$message.error(err.message || err);
        }).finally(()=>{
          
        }) 
      // }
    },
    
    addCounts(id){
      api.paymentCounts(id).then(res=>{
        this.$message.success("交费成功")
        this.cancel()
      }).catch(error=>{

      }).finally(()=>{
        this.meta.loading = false;
      })
    },
    cancel() {
      this.$emit("update:visible", false);
    },
    addFloat(num1, num2){
      num1 = parseFloat(num1).toFixed(2)
      num2 = parseFloat(num2).toFixed(2)
      let r1, r2, m;
      r1 = (''+num1).split('.')[1].length;
      r2 = (''+num2).split('.')[1].length;

      m = Math.pow(10,Math.max(r1,r2));
      return (num1 * m + num2 * m) / m;
    }
  },
  beforeRouteLeave (to,from, next) {
    return next();
  }
};
</script>

<style scoped>
.redaK{
  background-color: #909399;
}
.tx-r{
  text-align: right;
}

.tx-l{
  text-align: left;
}
.tx-c{
  text-align: center;
}
.pall10p{
  padding: 10px;
}


.patientBox {
  height: 5rem;
  margin-bottom: 2rem;
}

.el-row {
  margin-bottom: 10px;
}

.el-row:last-child {
  margin-bottom: 0px;
}

.ztitle {
  margin-top: 10px;
  color: #66b1ff;
}
.inputnw .el-input {
  width: 4rem !important;
}
.inputDelW {
  width: 12rem;
}
.el-form--inline .el-form-item{
  margin-right: 0px;
}

</style>
<style>
.nobd .el-table__cell{
  border-right: none !important;
}
.horMiddle{
 padding-top: 9px;
}

</style>
